// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

/* eslint-disable */

/**
 * This is a automatically generated component, do not edit it.
 * If you need to edit this component, move it to some other folder.
 */

import React from 'react';
function DrugIcon10(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      {...props}
    >
      <g
        fill="currentColor"
        clipPath="url(#a)"
      >
        <path d="M23.826 25.56h-7a.333.333 0 0 0 0 .667h7a.333.333 0 1 0 0-.666ZM11.273 6.893h-.303V5.26a1.41 1.41 0 0 0-1.41-1.41V2.153A1.36 1.36 0 0 0 8.2.793h-.434a1.36 1.36 0 0 0-1.36 1.36V3.85A1.413 1.413 0 0 0 5 5.26v1.633h-.304a.827.827 0 0 0-.823.823v1a.827.827 0 0 0 .823.824H5v17.366a3 3 0 0 0 1.713 2.7v1.13a1.277 1.277 0 0 0 2.333.71c.297-.443.217-.856.217-1.84a3 3 0 0 0 1.677-2.273c.046-.333.03.883.03-17.797h.303a.823.823 0 0 0 .823-.823v-1a.823.823 0 0 0-.823-.82Zm-4.2-4.74a.693.693 0 0 1 .693-.693H8.2a.693.693 0 0 1 .693.693V3.85h-1.82V2.153ZM5.666 5.26a.743.743 0 0 1 .744-.744h3.16a.743.743 0 0 1 .74.744v1.633H9.166V5.866a.333.333 0 0 0-.666 0v1.027h-1V5.866a.333.333 0 1 0-.667 0v1.027H5.666V5.26Zm0 21.63V15.706l.817-.263a2.137 2.137 0 0 1 1.667.16 2.814 2.814 0 0 0 2.163.217c0 12.053 0 11.166-.03 11.443a2.333 2.333 0 0 1-1.47 1.797.333.333 0 0 0-.213.31v1.356a.613.613 0 0 1-.6.607.607.607 0 0 1-.607-.607V29.37a.334.334 0 0 0-.217-.31 2.333 2.333 0 0 1-1.51-2.17Zm4.637-11.774-.177.06a2.138 2.138 0 0 1-1.666-.156 2.805 2.805 0 0 0-2.184-.21l-.61.19V9.526h4.637v5.59Zm1.127-6.413a.157.157 0 0 1-.157.157H4.69a.157.157 0 0 1-.157-.157v-1a.157.157 0 0 1 .157-.157h6.583a.157.157 0 0 1 .157.157v1Z" />
        <path d="m26.796 9.53-1.077-1v-2a1.667 1.667 0 0 0-1.667-1.667h-1.666V1.806A1.777 1.777 0 0 0 20.613.029h-.614a1.777 1.777 0 0 0-1.776 1.777v3.077h-1.667a1.667 1.667 0 0 0-1.667 1.666v2.017l-1.05.963a4.104 4.104 0 0 0-1.333 3v17.244a2.226 2.226 0 0 0 2.246 2.226h11.144a2.223 2.223 0 0 0 2.223-2.223V12.543a4.111 4.111 0 0 0-1.323-3.014Zm.643 13.736H13.193v-9.067h14.246v9.067Zm-14.246.667h14.246v3.92H13.193v-3.92Zm5.703-22.127a1.113 1.113 0 0 1 1.103-1.11h.607a1.113 1.113 0 0 1 1.11 1.11v3.077h-2.82V1.806Zm-3.334 4.74a1 1 0 0 1 1-1h7.497a1 1 0 0 1 1 1v1.82h-1.333V6.699a.333.333 0 0 0-.667 0v1.667h-1.393V6.699a.333.333 0 0 0-.667 0v1.667h-1.366V6.699a.333.333 0 1 0-.667 0v1.667h-1.38V6.699a.333.333 0 0 0-.667 0v1.667h-1.333l-.024-1.82Zm-1.266 3.473 1.077-1h9.896l1.074 1a3.436 3.436 0 0 1 1.11 2.524v1h-14.26v-1a3.452 3.452 0 0 1 1.11-2.524h-.007Zm11.6 21.314H14.752a1.56 1.56 0 0 1-1.56-1.557v-1.257h14.26v1.257a1.56 1.56 0 0 1-1.556 1.557Z" />
        <path d="M20.334 21.743a2.38 2.38 0 0 0 2.38-2.38c0-1.23-1.924-3.233-2.14-3.46a.335.335 0 0 0-.477 0c-.22.227-2.14 2.23-2.14 3.46a2.38 2.38 0 0 0 2.377 2.38Zm0-5.12c.743.813 1.713 2.09 1.713 2.74a1.713 1.713 0 1 1-3.423 0c-.01-.65.956-1.927 1.71-2.74Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path
            fill="#fff"
            d="M0 0h32v32H0z"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export default DrugIcon10;
